import * as React from 'react';
import { jsx } from 'react/jsx-runtime';
import { StyleSheet } from 'aphrodite';

function mergeTheme(source,target){const result={...source,...target};const objectKeys=Object.keys(result);for(const key of objectKeys){const sourceValue=source[key];const targetValue=target[key];result[key]=typeof targetValue==="object"&&typeof sourceValue==="object"?mergeTheme(sourceValue,targetValue):result[key];}return result}

function createThemeContext(theme){return React.createContext(theme)}

const ThemeSwitcherContext=React.createContext("default");

function useScopedTheme(themeContext){const theme=React.useContext(themeContext);const themeName=React.useContext(ThemeSwitcherContext)??"default";return {theme,themeName}}

function withScopedTheme(styleSheet,themeContext){return WrappedComponent=>props=>{const{theme}=useScopedTheme(themeContext);const wbThemeStyles=styleSheet(theme);return jsx(WrappedComponent,{...props,wbThemeStyles:wbThemeStyles})}}

function useStyles(styles,theme){const styleSheet=React.useMemo(()=>{return StyleSheet.create(styles(theme))},[styles,theme]);return styleSheet}

const THEME_DATA_ATTRIBUTE="data-wb-theme";

function ThemeSwitcher({theme,children}){if(!theme){return children}const props={[THEME_DATA_ATTRIBUTE]:theme};return jsx("div",{...props,children:children})}

export { THEME_DATA_ATTRIBUTE, ThemeSwitcher, ThemeSwitcherContext, createThemeContext, mergeTheme, useScopedTheme, useStyles, withScopedTheme };
